import { render, staticRenderFns } from "./ToolbarActiveProject.vue?vue&type=template&id=312dbaad&scoped=true"
import script from "./ToolbarActiveProject.vue?vue&type=script&lang=js"
export * from "./ToolbarActiveProject.vue?vue&type=script&lang=js"
import style0 from "./ToolbarActiveProject.vue?vue&type=style&index=0&id=312dbaad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312dbaad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VLayout,
})
